import api from "@/services/api/exercise/api-questions"
import QuestionItem from "@/app/exercise/components/question/core/models/questionModel"

export default class QuestionService {
  async create(model) {
    try {
      let res = await api.create(model.getApiData())
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async put(ID, model) {
    try {
      let res = await api.put(ID, model.getApiData())
      return new QuestionItem(res)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async uploadSubtitlesNl(ID, file) {
    try {
      let res = await api.uploadSubtitlesNl(ID, file)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async uploadSubtitlesEn(ID, file) {
    try {
      let res = await api.uploadSubtitlesEn(ID, file)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  // Video file is now handled as part of the question model
  
  async getQuestionVideo(ID) {
    try {
      let res = await api.get(ID)
      return res.video
    } catch (error) {
      return Promise.reject(error)
    }
  }
}
